import { Component, OnInit, Input, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ShoppingCartService } from 'src/app/core/services/shoppingCart.service';
import { AnimationController, ModalController } from '@ionic/angular';
import { NavService } from 'src/app/core/services/nav.service';
import { CashbackService } from 'src/app/core/services/cashback.service';
import { RestaurantService } from 'src/app/core';

@Component({
	selector: 'balance-cashback',
	templateUrl: './balance-cashback.component.html',
	styleUrls: ['./balance-cashback.component.scss'],
})

export class BalanceCashbackComponent implements OnInit {

	balance = {
		balance: 0,
		expirationDate: null
	};

	isNewFlowCheckout: boolean = !!this.restaurantService.restaurant?.info?.modules?.new_flow_checkout_pedir_delivery;

	constructor(
		private cashbackService: CashbackService,
		private navService: NavService,
		private restaurantService: RestaurantService,
		private shoppingCartService: ShoppingCartService,
		@Inject(PLATFORM_ID) private platformId: Object,
	) { }

	// A barra do carrinho do fluxo novo (.new-cart-bar) é FULL-WIDTH e fica logo acima da
	// tabs-bar, então o chip tem de subir para não ficar embaixo dela. Só que ela existe
	// apenas com item no carrinho (`*ngIf="products.length > 0"`, cart.component.html:1), e
	// reservar espaço para uma barra que não está na tela deixa o chip flutuando no meio do
	// cardápio, com um vão morto embaixo.
	//
	// A leitura de estado é a mesma do vizinho que divide este canto (o getter
	// `cartBarVisible` de featured-coupon-popup.component.ts), de propósito: os dois
	// respondem à mesma barra e não podem discordar sobre ela estar lá.
	get barraDoCarrinhoVisivel(): boolean {
		const products = this.shoppingCartService.products || [];

		return this.isNewFlowCheckout && products.length > 0;
	}

	ngOnInit() {
		// Saldo de cashback exige usuário autenticado (API + localStorage): browser-only.
		if (!isPlatformBrowser(this.platformId)) return;
		this.getBalance();
	}

	getBalance() {
		this.cashbackService.getCashbackBalance().then(response => {
		  this.balance = response;
		});
	}

	goToCashback() {
		this.navService.push('/cashback');
	}

}
